import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';
import EntityProjectsContext from '../../EntityProjects/context/EntityProjects.context';
import { useContext } from 'react';

const Loading = () => {
    const { infos } = useContext(EntityProjectsContext);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="60vh"
        >
            <CircularProgress
                sx={{
                    color: infos?.primary_color,
                    marginBottom: 2,
                    animationDuration: '800ms' 
                }}
            />
            <Typography variant="h6" marginTop={2}>
                Carregando...
            </Typography>
        </Box>
    );
};

export default Loading;
